// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__O97pD","label":"styles_label__2R21N"};